import React from "react";
import type { MessageOption } from "../types";
import OriStarterPillRow from "./OriStarterPillRow";

interface OriDynamicStarterPillsProps {
  options: MessageOption[];
  onSelect: (option: MessageOption, index: number) => void;
  disabled?: boolean;
}

const OriDynamicStarterPills: React.FC<OriDynamicStarterPillsProps> = ({
  options,
  onSelect,
  disabled = false,
}) => (
  <OriStarterPillRow
    testId="ori-dynamic-starters"
    items={options.map((option, index) => ({
      key: String(index),
      label: option.label,
      testId: `ori-dynamic-starter-${index}`,
    }))}
    onSelect={(index) => onSelect(options[index], index)}
    disabled={disabled}
  />
);

export default OriDynamicStarterPills;
